import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { articlesForPage, audiencesFor, hasArticles, loadKb } from "@/lib/kb";

// "Help for this page": opens the article(s) that list the current route in their
// `pages:` front matter. With no match it falls back to the Help index, and it renders
// nothing at all if the reader has no articles. `basePath` is the Help route for this shell.
export function PageHelpLink({ basePath, className, iconClassName, label }) {
  const { user, isWorker, isPortal } = useAuth();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [matches, setMatches] = useState([]);
  const audiences = audiencesFor({ isWorker, isPortal, role: user?.role });

  useEffect(() => {
    let live = true;
    loadKb().then((kb) => { if (live) setMatches(articlesForPage(kb, pathname, audiences)); }).catch(() => {});
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, audiences.join(",")]);

  if (!hasArticles(audiences)) return null;
  const go = () => nav(matches.length === 1 ? `${basePath}/${matches[0].slug}` : matches.length > 1 ? `${basePath}?page=${encodeURIComponent(pathname)}` : basePath);
  const title = matches.length > 0 ? "Help for this page" : "Help & guides";
  return (
    <button onClick={go} title={title} aria-label={title} data-testid="page-help" className={className}>
      <HelpCircle className={iconClassName} />{label}
    </button>
  );
}
